export default {
  API_URL: 'https://api.riffel.sync360.io/',
  TEST_USER: 'a',
  TEST_PASS: 'a',
  CLIENT_SECRET: 'xixEIqDF9Tit3tppXXT0Pi4Wfpl0QRU4qu6GAuSt',
  GRANT_TYPE: 'password',
  CLIENT_ID: '2',
  UPLOAD_LIMIT: 5,
  GOOGLE_API_KEY: 'AIzaSyBzIUqB05E72-WKfRnZj2G15bJr0nXdkDA',
  SUPERVISOR_ROLE_ID: 1,
};
